<template>
  <div
    class="support-ticket"
    @click="onTicketClick(current)"
  >
    <div class="st-meta">
      <div
        class="badge badge-success-inverted"
        v-if="!(current.estado == 'C' || current.estado == '9')"
      >
        {{ current.estado_str }}
      </div>
      <div class="badge badge-warning-inverted" v-if="current.estado == 'C'">
        {{ current.estado_str }}
      </div>
      <div class="badge badge-danger-inverted" v-if="current.estado == '9'">
        {{ current.estado_str }}
      </div>
      <i class="os-icon os-icon-ui-09"></i>
      <div
        class="status-pill green"
        v-if="!(current.estado == 'C' || current.estado == '9')"
      ></div>
      <div class="status-pill yellow" v-if="current.estado == 'C'"></div>
      <div class="status-pill red" v-if="current.estado == '9'"></div>
    </div>
    <div class="st-body">
      <div class="ticket-content">
        <h6 class="ticket-title"># {{ current.numero }}</h6>
        <div class="ticket-description">
          &nbsp; De: {{ current.tienda_origen_obj.nombre }}
          <br />
          &nbsp; Hacia: {{ current.tienda_destino_obj.nombre }}
          <br />
          <span class="text-success badge" v-if="current.tipo_traslado"
            >Tipo: {{ current.tipo_traslado_str }}</span
          >
        </div>
      </div>
    </div>
    <div class="st-foot">
      <span class="label">Usuario: &nbsp;</span>
      <UsuarioEnTablaComponent :current="current.usuario" />
      <span class="label">Creada:</span>
      <span class="value">
        <timeago
          locale="es"
          :title="current.fecha_creacion"
          :auto-update="60"
          :datetime="current.fecha_creacion"
        ></timeago>
      </span>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  props: {
    current: {
      type: Object,
    },
  },
  mounted() {},
  methods: {
    truncate(text, length, suffix) {
      if (text === undefined || text === null || text == "") {
        return "";
      }
      return text.substring(0, length) + suffix;
    },
    onTicketClick(current) {
      this.$emit("onTicketClick", current);
    },
  },
};
</script>
